// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_wkPdu","title":"index_title_guUmF","list_box":"index_list_box_J1BNL","more":"index_more_QNe25"};